import { useFormik } from 'formik'
import { InputText } from 'primereact/inputtext'
import { Button } from 'primereact/button'
import { classNames } from 'primereact/utils'
import phone from 'phone'
import { affiliateCreateLead } from './utils/createLead'
import { useMutation as useMutationRQ } from 'react-query'
import { Dispatch, SetStateAction } from 'react'
import { IsEmailValid } from './utils/email'

interface ICreateLeadProps {
  toggleSideBar: Dispatch<SetStateAction<boolean>>
  showResponse: (msg: string, isError: boolean) => void
  refetch: () => void
}

const CreateLeadDrawer: React.FC<ICreateLeadProps> = (props: ICreateLeadProps) => {
  const { showResponse, toggleSideBar, refetch } = props

  // create mutation
  const [createMutation, { isLoading: createLoading }] = useMutationRQ(affiliateCreateLead, {
    onSuccess: (data) => {
      if (data.statusCode || data.message) {
        showResponse(
          (data.message && data.message.message) ||
            (typeof data.message === 'string' && data.message) ||
            data.statusCode,
          true,
        )
      } else {
        // handlesuccess
        showResponse('Lead Created Successfully', false)
        formik.resetForm()
        toggleSideBar(false)
        refetch()
      }
    },
    onError: (er) => {
      console.log(er)
    },
  })

  const formik = useFormik({
    initialValues: {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      token: '',
      description: '',
    },
    validate: (data: any) => {
      let errors: any = {}

      if (!data.token) {
        errors.token = 'Affiliate Token is required.'
      }
      if (!data.firstName) {
        errors.firstName = 'First Name is required.'
      }

      if (!data.lastName) {
        errors.lastName = 'Last Name is required.'
      }

      if (!data.phone || !phone(data.phone).isValid) {
        errors.phone = 'Phone number is required.'
      }

      if (!data.email) {
        errors.email = 'Email is required.'
      } else if (!IsEmailValid(data.email)) {
        errors.email = 'Invalid email address. E.g. example@email.com'
      }

      return errors
    },
    onSubmit: (data) => {
      // submit the date
      createMutation(data)
    },
  })

  const isFormFieldValid = (name: 'firstName' | 'lastName' | 'email' | 'phone' | 'token') =>
    !!(formik.touched[name] && formik.errors[name])
  const getFormErrorMessage = (name: 'firstName' | 'lastName' | 'email' | 'phone' | 'token') => {
    return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>
  }

  return (
    <div className="create__drawer">
      <h2>Create New Lead</h2>
      <div className="p-mt-5">
        <div className="card">
          <form onSubmit={formik.handleSubmit} className="p-fluid">
            <div className="p-field p-mt-5">
              <span className="p-float-label">
                <InputText
                  id="token"
                  name="token"
                  value={formik.values.token}
                  onChange={formik.handleChange}
                  autoFocus
                  className={classNames({
                    'p-invalid': isFormFieldValid('token'),
                  })}
                />
                <label
                  htmlFor="name"
                  className={classNames({
                    'p-error': isFormFieldValid('token'),
                  })}
                >
                  Affiliate Token
                </label>
              </span>
              {getFormErrorMessage('token')}
            </div>
            <div className="p-field p-mt-5">
              <span className="p-float-label">
                <InputText
                  id="firstName"
                  name="firstName"
                  value={formik.values.firstName}
                  onChange={formik.handleChange}
                  autoFocus
                  className={classNames({
                    'p-invalid': isFormFieldValid('firstName'),
                  })}
                />
                <label
                  htmlFor="name"
                  className={classNames({
                    'p-error': isFormFieldValid('firstName'),
                  })}
                >
                  First Name*
                </label>
              </span>
              {getFormErrorMessage('firstName')}
            </div>
            <div className="p-field p-mt-5">
              <span className="p-float-label">
                <InputText
                  id="lastName"
                  name="lastName"
                  value={formik.values.lastName}
                  onChange={formik.handleChange}
                  autoFocus
                  className={classNames({
                    'p-invalid': isFormFieldValid('lastName'),
                  })}
                />
                <label
                  htmlFor="name"
                  className={classNames({
                    'p-error': isFormFieldValid('lastName'),
                  })}
                >
                  Last Name*
                </label>
              </span>
              {getFormErrorMessage('lastName')}
            </div>
            <div className="p-field p-mt-5">
              <span className="p-float-label p-input-icon-right">
                <i className="pi pi-envelope" />
                <InputText
                  id="email"
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  className={classNames({
                    'p-invalid': isFormFieldValid('email'),
                  })}
                />
                <label
                  htmlFor="email"
                  className={classNames({
                    'p-error': isFormFieldValid('email'),
                  })}
                >
                  Email*
                </label>
              </span>
              {getFormErrorMessage('email')}
            </div>
            <div className="p-field p-mt-5">
              <span className="p-float-label">
                <InputText
                  id="phone"
                  name="phone"
                  value={formik.values.phone}
                  onChange={formik.handleChange}
                  className={classNames({
                    'p-invalid': isFormFieldValid('phone'),
                  })}
                />
                <label
                  htmlFor="phone"
                  className={classNames({
                    'p-error': isFormFieldValid('phone'),
                  })}
                >
                  Phone Number*
                </label>
              </span>
              {getFormErrorMessage('phone')}
            </div>
            <div className="p-field p-mt-5">
              <span className="p-float-label">
                <InputText
                  id="description"
                  name="description"
                  value={formik.values.description}
                  onChange={formik.handleChange}
                  autoFocus
                />
                <label htmlFor="name">Description</label>
              </span>
            </div>
            <Button loading={createLoading} type="submit" label="Submit" className="p-mt-2" />
          </form>
        </div>
      </div>
    </div>
  )
}

export default CreateLeadDrawer
